import { Box } from '@hivebrite/design-system/Box';
import { Slider } from '@hivebrite/design-system/Slider';

import type { StorageAttachment } from 'hb-react/frontoffice/apps/Forum/types';

import Attachment from './Attachment';

const CARDS_PER_ROW = {
  s: 2,
  m: 2,
  l: 3,
  xl: 3,
};

interface AttachmentsSliderProps {
  storageAttachments: StorageAttachment[];
}

const AttachmentsSlider = ({ storageAttachments }: AttachmentsSliderProps) => {
  if (!storageAttachments?.length) {
    return null;
  }

  return (
    <Box width="100%" display="block">
      <Slider
        items={storageAttachments}
        ItemComponent={Attachment}
        perPageBreakpoints={CARDS_PER_ROW}
        infinite={false}
        LoadingItemComponent={Box}
        total={storageAttachments.length}
      />
    </Box>
  );
};

export default AttachmentsSlider;
